import React from 'react';
import { Drawer, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import type { DrawerProps } from 'antd';
import useIsMobile from '../../hooks/useIsMobile';

interface MobileDrawerProps extends DrawerProps {
    children?: React.ReactNode;
}

const MobileDrawer: React.FC<MobileDrawerProps> = ({ children, ...props }) => {
    const isMobile = useIsMobile();
    const { width, ...restProps } = props;

    // Convert deprecated `width` prop to styles.wrapper.width
    const existingStyles = typeof restProps.styles === 'function' ? undefined : restProps.styles;
    const mergedStyles = width
        ? { ...existingStyles, wrapper: { width, ...((existingStyles as any)?.wrapper || {}) } }
        : restProps.styles;

    if (!isMobile) {
        return <Drawer {...restProps} styles={mergedStyles}>{children}</Drawer>;
    }

    // On mobile: full-screen drawer with back-arrow header
    const { title, onClose, footer, open, extra, styles: _styles, ...rest } = restProps;

    return (
        <Drawer
            {...rest}
            open={open}
            onClose={onClose}
            placement="right"
            styles={{
                wrapper: { width: '100%' },
                header: { padding: '12px 16px' },
                body: { padding: '16px', overflowY: 'auto' },
                footer: { padding: '12px 16px' },
                ...(restProps.styles || {}),
            }}
            height="100%"
            title={
                <div className="flex items-center gap-2">
                    <Button
                        type="text"
                        size="small"
                        icon={<ArrowLeftOutlined />}
                        onClick={onClose as any}
                        className="shrink-0 -ml-1"
                    />
                    <span className="truncate font-semibold">{title}</span>
                </div>
            }
            footer={footer}
            extra={extra}
            closeIcon={false}
        >
            {children}
        </Drawer>
    );
};

export default MobileDrawer;
